module.exports = __webpack_public_path__ + "img/leage_best_toast.bb7f35eb.png";